import script from "./payments.vue?vue&type=script&setup=true&lang=js"
export * from "./payments.vue?vue&type=script&setup=true&lang=js"

import "./payments.vue?vue&type=style&index=0&id=2fcc96ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fcc96ae"]])

export default __exports__